module.exports = __webpack_public_path__ + "static/all-in-one-place.0dcb90e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/all-in-one-place.png
// module id = 664
// module chunks = 35783957827783